import messages_fr from "translations/fr.json";
import messages_en from "translations/en.json";
import commonUtilities from "utilities/common";
import { marked } from "marked";

const messages = { "fr": messages_fr, "en": messages_en };

/**
 * Localize the content by a key, and by the current user language, It will check injected localizer first.
 *
 * @param {String} key - content key.
 * @param {Object} localize - the injected localizer from the caller.
 * @returns {String} the content you are looking for and to be localized.
 */
export const Localize = (key, localize) => {
    if(localize) {
        return localize(key);
    }
    else {
        return LocalizeByCurrentUserPreferenceLanguage(key);
    }
};

/**
 * Localize the content by a key, and by the current user language, from a collection if provided
 *
 * @param {String} key - content key.
 * @param {Array} collection - the collection against which you want to localize.
 * @returns {String} the content you are looking for and to be localized.
 */
export const LocalizeByCurrentUserPreferenceLanguage = (key, collection = null) => {
    const lang = commonUtilities.getLanguage();
    return LocalizeByLang(key, lang, collection);
};

/**
 * Localize the content by a key, and by provided language, from a collection if provided
 * It will localize content against collection first, if provided. If the collection is not present, it will localize against json message file
 *
 * @param {String} key - content key.
 * @param {String} lang - language.
 * @param {Array} collection - the collection against which you want to localize.
 * @returns {String} the content you are looking for and to be localized.
 */
export const LocalizeByLang = (key, lang, collection = null) => {
    let _lang = lang?.toLowerCase();
    if(collection && collection.length > 0) {
        const index = collection.findIndex((item) => item?.key === key);
        if(index > -1) {
            const parseAsMarkdown = collection[index]?.parseAsMarkdown ?? false;

            let value = collection[index].englishValue;

            if(_lang === "fr") {
                value = collection[index].frenchValue;
            }
            
            if (parseAsMarkdown) {
                // Convert Markdown to HTML
                const dirty = marked.parse(value || "");

                // Safe to render
                return commonUtilities.parseHtml(dirty);
            }

            return value;
        }
    }
    return messages?.[_lang]?.[key];
};

/**
 * Get current user preference language code
 *
 * @returns {String} the language code, for current user.
 */
export const GetLanguageCode = () => {
    const lang = commonUtilities.getLanguage();
    return lang;
};